var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Alert, Box, Button, CircularProgress, Collapse, Grid, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Typography, } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import PreviewIcon from "@mui/icons-material/Preview";
import RefreshIcon from "@mui/icons-material/Refresh";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { alpha, useTheme } from "@mui/material/styles";
import { Confirm, useDataProvider, useGetIdentity, useNotify, useTranslate, } from "react-admin";
import BatchPreview from "./BatchPreview";
import BulkGenerationQuota from "./BulkGenerationQuota";
import BatchHistoryFilterList, { buildBatchHistoryFilterParams, emptyBatchHistoryFilters, } from "./BatchHistoryFilterList";
import { isActiveStatus, isTerminalStatus, StatusChip } from "./BatchProgress";
var HISTORY_REQUEST_SIZE = 100;
var HISTORY_FILTER_KEY = "".concat(window.location.pathname, "_history_filter");
var getBatchSortValue = function (batch, field) {
    var _a, _b, _c;
    switch (field) {
        case "report_status":
            return (_b = (_a = batch.latest_report_job) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : "";
        default:
            return (_c = batch[field]) !== null && _c !== void 0 ? _c : "";
    }
};
var compareBatches = function (left, right, field, order) {
    var leftValue = getBatchSortValue(left, field);
    var rightValue = getBatchSortValue(right, field);
    var result = String(leftValue).localeCompare(String(rightValue), undefined, {
        numeric: true,
        sensitivity: "base",
    });
    return order === "asc" ? result : -result;
};
var matchesDateRange = function (createdAt, from, to) {
    var createdDate = createdAt.split("T")[0].split(" ")[0];
    if (from && createdDate < from)
        return false;
    if (to && createdDate > to)
        return false;
    return true;
};
var applyBatchHistoryFilters = function (batches, filters) {
    return batches.filter(function (batch) {
        var _a, _b, _c, _d;
        var nameQuery = (_a = filters.name) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase();
        if (nameQuery && !batch.name.toLowerCase().includes(nameQuery))
            return false;
        var archiveQuery = (_b = filters.archive) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase();
        if (archiveQuery &&
            !batch.archive_original_name.toLowerCase().includes(archiveQuery)) {
            return false;
        }
        if (!matchesDateRange(batch.created_at, filters.createdFrom, filters.createdTo)) {
            return false;
        }
        if (filters.importStatus && batch.import_status !== filters.importStatus) {
            return false;
        }
        var reportStatus = (_d = (_c = batch.latest_report_job) === null || _c === void 0 ? void 0 : _c.status) !== null && _d !== void 0 ? _d : "";
        if (filters.reportStatus && reportStatus !== filters.reportStatus) {
            return false;
        }
        return true;
    });
};
var BatchHistory = function (_a) {
    var isActive = _a.isActive, refreshKey = _a.refreshKey, onContinueOperation = _a.onContinueOperation, onQuotaChange = _a.onQuotaChange, _b = _a.remainingQuota, remainingQuota = _b === void 0 ? null : _b, _c = _a.quotaLoading, quotaLoading = _c === void 0 ? false : _c;
    var dataProvider = useDataProvider();
    var identity = useGetIdentity().identity;
    var notify = useNotify();
    var translate = useTranslate();
    var theme = useTheme();
    var _d = useState([]), batches = _d[0], setBatches = _d[1];
    var _e = useState(null), selectedBatchId = _e[0], setSelectedBatchId = _e[1];
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var _g = useState(false), filterLoading = _g[0], setFilterLoading = _g[1];
    var _h = useState(null), downloadingId = _h[0], setDownloadingId = _h[1];
    var _j = useState(null), downloadingReportsId = _j[0], setDownloadingReportsId = _j[1];
    var _k = useState(null), retryingId = _k[0], setRetryingId = _k[1];
    var _l = useState(null), regeneratingId = _l[0], setRegeneratingId = _l[1];
    var _m = useState(null), reconcilingId = _m[0], setReconcilingId = _m[1];
    var _o = useState(null), deletingId = _o[0], setDeletingId = _o[1];
    var _p = useState(null), batchToDelete = _p[0], setBatchToDelete = _p[1];
    var _q = useState(null), error = _q[0], setError = _q[1];
    var _r = useState(0), page = _r[0], setPage = _r[1];
    var _s = useState(10), rowsPerPage = _s[0], setRowsPerPage = _s[1];
    var _t = useState(emptyBatchHistoryFilters), filters = _t[0], setFilters = _t[1];
    var _u = useState(emptyBatchHistoryFilters), appliedFilters = _u[0], setAppliedFilters = _u[1];
    var _v = useState("created_at"), sortField = _v[0], setSortField = _v[1];
    var _w = useState("desc"), sortOrder = _w[0], setSortOrder = _w[1];
    var filterParams = useMemo(function () { return buildBatchHistoryFilterParams(translate); }, [translate]);
    useEffect(function () {
        var storedFilters = sessionStorage.getItem(HISTORY_FILTER_KEY);
        if (!storedFilters)
            return;
        try {
            var parsedFilters = __assign(__assign({}, emptyBatchHistoryFilters()), JSON.parse(storedFilters));
            setFilters(parsedFilters);
            setAppliedFilters(parsedFilters);
        }
        catch (_a) {
            sessionStorage.removeItem(HISTORY_FILTER_KEY);
        }
    }, []);
    var loadHistory = useCallback(function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (silent) {
            var firstPage, pageCount, remainingPages, allBatches, caughtError_1;
            if (silent === void 0) { silent = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(identity === null || identity === void 0 ? void 0 : identity.id))
                            return [2 /*return*/];
                        if (silent) {
                            setFilterLoading(true);
                        }
                        else {
                            setLoading(true);
                        }
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, dataProvider.getBatchHistory(1, HISTORY_REQUEST_SIZE)];
                    case 2:
                        firstPage = _a.sent();
                        pageCount = Math.ceil(firstPage.total / HISTORY_REQUEST_SIZE);
                        return [4 /*yield*/, Promise.all(Array.from({ length: Math.max(0, pageCount - 1) }, function (_, index) {
                                return dataProvider.getBatchHistory(index + 2, HISTORY_REQUEST_SIZE);
                            }))];
                    case 3:
                        remainingPages = _a.sent();
                        allBatches = __spreadArray(__spreadArray([], firstPage.data, true), remainingPages.flatMap(function (response) { return response.data; }), true);
                        setBatches(allBatches.filter(function (batch) { return batch.operator_id === identity.id; }));
                        return [3 /*break*/, 6];
                    case 4:
                        caughtError_1 = _a.sent();
                        setError((caughtError_1 === null || caughtError_1 === void 0 ? void 0 : caughtError_1.message) || translate("pages.bulkGeneration.notify.historyFailed"));
                        return [3 /*break*/, 6];
                    case 5:
                        if (silent) {
                            setFilterLoading(false);
                        }
                        else {
                            setLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }, [dataProvider, identity === null || identity === void 0 ? void 0 : identity.id, translate]);
    useEffect(function () {
        if (!isActive || !(identity === null || identity === void 0 ? void 0 : identity.id))
            return;
        void loadHistory(refreshKey > 1);
    }, [isActive, identity === null || identity === void 0 ? void 0 : identity.id, refreshKey, loadHistory]);
    var refreshHistory = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadHistory(true)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [loadHistory]);
    var searchHistory = useCallback(function () {
        setFilterLoading(true);
        setAppliedFilters(__assign({}, filters));
        setPage(0);
        sessionStorage.setItem(HISTORY_FILTER_KEY, JSON.stringify(filters));
        window.setTimeout(function () { return setFilterLoading(false); }, 150);
    }, [filters]);
    var clearFilters = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var empty;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    empty = emptyBatchHistoryFilters();
                    setFilterLoading(true);
                    setFilters(empty);
                    setAppliedFilters(empty);
                    setPage(0);
                    setSelectedBatchId(null);
                    sessionStorage.removeItem(HISTORY_FILTER_KEY);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, loadHistory(true)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setFilterLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [loadHistory]);
    var filteredBatches = useMemo(function () { return applyBatchHistoryFilters(batches, appliedFilters); }, [appliedFilters, batches]);
    var sortedBatches = useMemo(function () {
        return __spreadArray([], filteredBatches, true).sort(function (left, right) {
            return compareBatches(left, right, sortField, sortOrder);
        });
    }, [filteredBatches, sortField, sortOrder]);
    var visibleBatches = useMemo(function () {
        return sortedBatches.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [page, rowsPerPage, sortedBatches]);
    var handleSort = function (field) {
        if (sortField === field) {
            setSortOrder(function (current) { return (current === "asc" ? "desc" : "asc"); });
            return;
        }
        setSortField(field);
        setSortOrder("asc");
        setPage(0);
    };
    var getRowStyle = function (batchId) {
        var isSelected = selectedBatchId === batchId;
        return __assign({ border: "1px solid Gainsboro" }, (isSelected
            ? {
                backgroundColor: alpha(theme.palette.primary.main, 0.09),
                boxShadow: "inset 3px 0 0 ".concat(theme.palette.primary.main),
                transition: theme.transitions.create(["background-color", "box-shadow"], {
                    duration: theme.transitions.duration.short,
                }),
            }
            : {}));
    };
    var renderSortLabel = function (field, label) { return (_jsx(TableSortLabel, { active: sortField === field, direction: sortField === field ? sortOrder : "asc", onClick: function () { return handleSort(field); }, children: label })); };
    var handleToggleDetails = function (batch) { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, caughtError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (selectedBatchId === batch.id) {
                        setSelectedBatchId(null);
                        return [2 /*return*/];
                    }
                    setSelectedBatchId(null);
                    setReconcilingId(batch.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.reconcileBatchStatus(batch.id)];
                case 2:
                    response_1 = _a.sent();
                    setBatches(function (current) {
                        return current.map(function (item) {
                            return item.id === batch.id ? __assign(__assign({}, item), response_1.data) : item;
                        });
                    });
                    return [3 /*break*/, 5];
                case 3:
                    caughtError_2 = _a.sent();
                    notify((caughtError_2 === null || caughtError_2 === void 0 ? void 0 : caughtError_2.message) || translate("pages.bulkGeneration.notify.previewFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setReconcilingId(null);
                    setSelectedBatchId(batch.id);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDownload = function (batch) { return __awaiter(void 0, void 0, void 0, function () {
        var caughtError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDownloadingId(batch.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.downloadBatchArchive(batch.id, batch.archive_original_name)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    caughtError_3 = _a.sent();
                    notify((caughtError_3 === null || caughtError_3 === void 0 ? void 0 : caughtError_3.message) || translate("pages.bulkGeneration.notify.downloadFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setDownloadingId(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRetryReports = function (batch) { return __awaiter(void 0, void 0, void 0, function () {
        var reportJob, response, caughtError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    reportJob = batch.latest_report_job;
                    if (!reportJob)
                        return [2 /*return*/];
                    setRetryingId(batch.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, dataProvider.retryReportTasks(reportJob.id)];
                case 2:
                    response = _a.sent();
                    notify(translate("pages.bulkGeneration.notify.reportQueued"), {
                        type: "success",
                    });
                    onContinueOperation(batch, response.data);
                    return [4 /*yield*/, (onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange())];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    caughtError_4 = _a.sent();
                    notify((caughtError_4 === null || caughtError_4 === void 0 ? void 0 : caughtError_4.message) || translate("pages.bulkGeneration.notify.retryFailed"), { type: "error" });
                    return [3 /*break*/, 6];
                case 5:
                    setRetryingId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleRegenerate = function (batch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, caughtError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRegeneratingId(batch.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, dataProvider.createBatchReport(batch.id)];
                case 2:
                    response = _a.sent();
                    notify(translate("pages.bulkGeneration.notify.reportQueued"), {
                        type: "success",
                    });
                    onContinueOperation(batch, response.data);
                    return [4 /*yield*/, (onQuotaChange === null || onQuotaChange === void 0 ? void 0 : onQuotaChange())];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    caughtError_5 = _a.sent();
                    notify((caughtError_5 === null || caughtError_5 === void 0 ? void 0 : caughtError_5.message) || translate("pages.bulkGeneration.notify.reportFailed"), { type: "error" });
                    return [3 /*break*/, 6];
                case 5:
                    setRegeneratingId(null);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDownloadReports = function (batch) { return __awaiter(void 0, void 0, void 0, function () {
        var caughtError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDownloadingReportsId(batch.id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.downloadBatchReports(batch.id, "".concat(batch.name, "-reports.zip"))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    caughtError_6 = _a.sent();
                    notify((caughtError_6 === null || caughtError_6 === void 0 ? void 0 : caughtError_6.message) ||
                        translate("pages.bulkGeneration.notify.reportDownloadFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setDownloadingReportsId(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var batchId, caughtError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!batchToDelete)
                        return [2 /*return*/];
                    batchId = batchToDelete.id;
                    setDeletingId(batchId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, dataProvider.deleteBatch(batchId)];
                case 2:
                    _a.sent();
                    setBatches(function (current) { return current.filter(function (batch) { return batch.id !== batchId; }); });
                    if (selectedBatchId === batchId)
                        setSelectedBatchId(null);
                    setPage(0);
                    notify(translate("pages.bulkGeneration.notify.deleted"), {
                        type: "success",
                    });
                    setBatchToDelete(null);
                    return [3 /*break*/, 5];
                case 3:
                    caughtError_7 = _a.sent();
                    notify((caughtError_7 === null || caughtError_7 === void 0 ? void 0 : caughtError_7.message) || translate("pages.bulkGeneration.notify.deleteFailed"), { type: "error" });
                    return [3 /*break*/, 5];
                case 4:
                    setDeletingId(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (loading && batches.length === 0) {
        return (_jsx(Box, { display: "flex", justifyContent: "center", py: 8, children: _jsx(CircularProgress, {}) }));
    }
    return (_jsxs(Grid, { container: true, rowGap: 1, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(BatchHistoryFilterList, { translate: translate, search: searchHistory, onClear: clearFilters, onRefresh: refreshHistory, isLoading: filterLoading || loading, params: filterParams, filters: filters, setFilters: setFilters }) }), _jsx(Grid, { item: true, xs: 12, children: _jsx(BulkGenerationQuota, { remainingQuota: remainingQuota, loading: quotaLoading }) }), _jsxs(Grid, { item: true, xs: 12, children: [error && _jsx(Alert, { severity: "error", children: error }), !error && batches.length === 0 && (_jsx(Alert, { severity: "info", children: translate("pages.bulkGeneration.history.empty") })), !error && batches.length > 0 && filteredBatches.length === 0 && (_jsx(Alert, { severity: "info", children: translate("pages.bulkGeneration.history.noResults") })), !error && filteredBatches.length > 0 && (_jsx(Box, { sx: { width: "100%", overflowX: "auto" }, children: _jsxs(TableContainer, { component: Paper, variant: "outlined", children: [_jsxs(Table, { sx: { tableLayout: "fixed", minWidth: "100%" }, children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: renderSortLabel("name", translate("pages.bulkGeneration.history.batchName")) }), _jsx(TableCell, { children: renderSortLabel("archive_original_name", translate("pages.bulkGeneration.history.archive")) }), _jsx(TableCell, { children: renderSortLabel("created_at", translate("pages.bulkGeneration.history.created")) }), _jsx(TableCell, { children: renderSortLabel("import_status", translate("pages.bulkGeneration.history.importStatus")) }), _jsx(TableCell, { children: renderSortLabel("report_status", translate("pages.bulkGeneration.history.reportStatus")) }), _jsx(TableCell, { children: translate("pages.bulkGeneration.history.actions") })] }) }), _jsx(TableBody, { children: visibleBatches.map(function (batch) {
                                                var _a, _b;
                                                var reportJob = batch.latest_report_job;
                                                var hasFailedReports = Boolean(reportJob === null || reportJob === void 0 ? void 0 : reportJob.failed_tasks) &&
                                                    isTerminalStatus(reportJob === null || reportJob === void 0 ? void 0 : reportJob.status);
                                                var hasSuccessfulReports = ((_a = reportJob === null || reportJob === void 0 ? void 0 : reportJob.success_tasks) !== null && _a !== void 0 ? _a : 0) > 0;
                                                var reportInProgress = isActiveStatus(reportJob === null || reportJob === void 0 ? void 0 : reportJob.status);
                                                var deletionBlocked = isActiveStatus(batch.import_status) || reportInProgress;
                                                return (_jsxs(React.Fragment, { children: [_jsxs(TableRow, { hover: true, sx: getRowStyle(batch.id), children: [_jsx(TableCell, { children: _jsx(Typography, { className: "small-text", children: batch.name }) }), _jsx(TableCell, { children: _jsx(Typography, { className: "small-text", children: batch.archive_original_name }) }), _jsx(TableCell, { children: _jsx(Typography, { className: "small-text", children: batch.created_at.split("T")[0].split(" ")[0] }) }), _jsx(TableCell, { children: _jsx(Box, { sx: { display: "flex", alignItems: "center" }, children: _jsx(StatusChip, { status: batch.import_status }) }) }), _jsx(TableCell, { children: _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 0.5 }, children: [_jsx(StatusChip, { status: (_b = batch.latest_report_job) === null || _b === void 0 ? void 0 : _b.status }), !batch.latest_report_job && (_jsx(Typography, { className: "small-text", children: "\u2014" }))] }) }), _jsx(TableCell, { children: _jsxs(Grid, { item: true, display: "flex", flexWrap: "wrap", children: [_jsx(Grid, { item: true, children: _jsx(Tooltip, { title: translate("pages.bulkGeneration.actions.view"), children: _jsx(IconButton, { size: "small", "aria-label": "preview", color: "inherit", onClick: function (event) {
                                                                                            event.stopPropagation();
                                                                                            handleToggleDetails(batch);
                                                                                        }, disabled: reconcilingId === batch.id, children: reconcilingId === batch.id
                                                                                            ? _jsx(CircularProgress, { size: 16 })
                                                                                            : _jsx(PreviewIcon, { fontSize: "small" }) }) }) }), _jsx(Grid, { item: true, children: _jsx(Tooltip, { title: translate("pages.bulkGeneration.actions.download"), children: _jsx("span", { children: _jsx(IconButton, { size: "small", "aria-label": "download", color: "inherit", onClick: function (event) {
                                                                                                event.stopPropagation();
                                                                                                handleDownload(batch);
                                                                                            }, disabled: downloadingId === batch.id, children: downloadingId === batch.id
                                                                                                ? _jsx(CircularProgress, { size: 16 })
                                                                                                : _jsx(DownloadIcon, { fontSize: "small" }) }) }) }) }), _jsx(Grid, { item: true, onClick: function (event) {
                                                                                    event.stopPropagation();
                                                                                    if (!deletionBlocked && deletingId !== batch.id) {
                                                                                        setBatchToDelete(batch);
                                                                                    }
                                                                                }, children: _jsx(Tooltip, { title: translate(deletionBlocked
                                                                                        ? "pages.bulkGeneration.actions.deleteUnavailable"
                                                                                        : "pages.bulkGeneration.actions.delete"), children: _jsx("span", { children: _jsx(IconButton, { size: "small", "aria-label": "delete", color: "inherit", disabled: deletingId === batch.id || deletionBlocked, children: deletingId === batch.id
                                                                                                ? _jsx(CircularProgress, { size: 16 })
                                                                                                : _jsx(DeleteIcon, { fontSize: "small" }) }) }) }) })] }) })] }), _jsx(TableRow, { children: _jsx(TableCell, { sx: { p: 0, borderBottom: 0 }, colSpan: 6, children: _jsx(Collapse, { in: selectedBatchId === batch.id, timeout: "auto", unmountOnExit: true, children: _jsxs(Box, { sx: {
                                                                            p: { xs: 2, md: 3 },
                                                                            bgcolor: "grey.50",
                                                                            borderTop: 1,
                                                                            borderColor: "divider",
                                                                        }, children: [_jsx(BatchPreview, { batchId: batch.id, onQuotaChange: onQuotaChange }), _jsxs(Stack, { direction: "row", justifyContent: "flex-end", spacing: 1.5, mt: 3, children: [_jsx(Button, { variant: "outlined", startIcon: _jsx(DownloadIcon, {}), onClick: function () { return handleDownload(batch); }, disabled: downloadingId === batch.id, children: translate("pages.bulkGeneration.actions.download") }), hasFailedReports && (_jsx(Button, { variant: "outlined", color: "warning", startIcon: retryingId === batch.id
                                                                                            ? _jsx(CircularProgress, { size: 16 })
                                                                                            : _jsx(RefreshIcon, {}), onClick: function () { return handleRetryReports(batch); }, disabled: Boolean(retryingId || regeneratingId), children: translate("pages.bulkGeneration.actions.retryReports") })), _jsx(Button, { variant: "contained", startIcon: regeneratingId === batch.id
                                                                                            ? _jsx(CircularProgress, { size: 16, color: "inherit" })
                                                                                            : _jsx(RestartAltIcon, {}), onClick: function () { return handleRegenerate(batch); }, disabled: Boolean(regeneratingId || retryingId || reportInProgress), children: translate("pages.bulkGeneration.actions.regenerateBatch") }), hasSuccessfulReports && (_jsx(Button, { variant: "contained", startIcon: downloadingReportsId === batch.id
                                                                                            ? _jsx(CircularProgress, { size: 16, color: "inherit" })
                                                                                            : _jsx(FolderZipOutlinedIcon, {}), onClick: function () { return handleDownloadReports(batch); }, disabled: downloadingReportsId === batch.id, children: translate("pages.bulkGeneration.actions.downloadReports") }))] })] }) }) }) })] }, batch.id));
                                            }) })] }), _jsx(TablePagination, { component: "div", count: filteredBatches.length, page: page, rowsPerPage: rowsPerPage, onPageChange: function (_event, nextPage) { return setPage(nextPage); }, onRowsPerPageChange: function (event) {
                                        setRowsPerPage(parseInt(event.target.value, 10));
                                        setPage(0);
                                    }, rowsPerPageOptions: [10, 25, 50] })] }) }))] }), _jsx(Confirm, { isOpen: Boolean(batchToDelete), title: translate("pages.bulkGeneration.delete.title"), content: translate("pages.bulkGeneration.delete.content", {
                    name: batchToDelete === null || batchToDelete === void 0 ? void 0 : batchToDelete.name,
                }), onConfirm: handleDelete, onClose: function () { return setBatchToDelete(null); }, loading: Boolean(deletingId) })] }));
};
export default BatchHistory;
